import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import Text from '../../../Text'
import { getCalendarGridPopoverSecondaryLabel } from '../../CalendarGrid.utils'
import { CalendarGridCard } from '../../CalendarGridCard'
import { CalendarGridItemStatus } from '../../CalendarGridItemStatus'
import { QA_NAME_CALENDAR_GRID_ITEM_CARD } from '../CalendarGridItemCard.constants'

import { getCalendarGridItemCardHeaderText } from './CalendarGridItemCardDefault.utils'

function CalendarGridItemCardDefault({ item, onClose }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const secondaryLabel = getCalendarGridPopoverSecondaryLabel(item)

  return (
    <CalendarGridCard
      headerText={getCalendarGridItemCardHeaderText({
        item,
        locale,
        t,
        timezone,
      })}
      qaName={QA_NAME_CALENDAR_GRID_ITEM_CARD}
      title={item.title}
      titleUrl={item.url}
      onClose={onClose}
    >
      <CalendarGridItemStatus item={item} />
      {secondaryLabel ? <Text isSecondary>{secondaryLabel}</Text> : null}
    </CalendarGridCard>
  )
}

export default CalendarGridItemCardDefault
